// extracted by mini-css-extract-plugin
module.exports = {"container":"topProjectedFantasy_container__V3VGD","playerPoints":"topProjectedFantasy_playerPoints___5qzI","playerPointsLabel":"topProjectedFantasy_playerPointsLabel__JH5vI"};